/**
 * WizardStepClauses — Step 5: Clauses, autorisations, conditions d'accueil.
 * Extracted from ContractWizard.jsx for maintainability.
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { ShieldCheck, FileText, Baby } from 'lucide-react';

export const WizardStepClauses = ({ data, onChange, children }) => (
  <div className="space-y-5">
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <ShieldCheck className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Autorisations & Sécurité
      </h3>
      <div className="space-y-3">
        <div className="flex items-center justify-between p-3 rounded-lg border border-[var(--neutral-200)]">
          <div>
            <Label className="font-semibold text-sm cursor-pointer">Autorisation d'intervention médicale d'urgence</Label>
            <p className="text-xs text-[var(--text-secondary)] mt-0.5">Le parent autorise l'assistante maternelle à faire intervenir les services d'urgence</p>
          </div>
          <Switch checked={data.medical_authorization} onCheckedChange={(checked) => onChange({ ...data, medical_authorization: checked })} data-testid="wizard-medical-auth" />
        </div>
        <div className="flex items-center justify-between p-3 rounded-lg border border-[var(--neutral-200)]">
          <div>
            <Label className="font-semibold text-sm cursor-pointer">Autorisation de transport en véhicule</Label>
            <p className="text-xs text-[var(--text-secondary)] mt-0.5">L'assistante maternelle est autorisée à transporter l'enfant</p>
          </div>
          <Switch checked={data.transport_authorization} onCheckedChange={(checked) => onChange({ ...data, transport_authorization: checked })} data-testid="wizard-transport-auth" />
        </div>
      </div>
    </div>
    <Separator />
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <FileText className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Conditions d'accueil
      </h3>
      <div>
        <Label>Conditions et limites des sorties hors du domicile</Label>
        <Textarea value={data.outing_conditions} onChange={(e) => onChange({ ...data, outing_conditions: e.target.value })} rows={2} data-testid="wizard-outing-conditions" />
      </div>
      <div>
        <Label>Personnes autorisées à récupérer l'enfant</Label>
        <Textarea value={data.authorized_persons} onChange={(e) => onChange({ ...data, authorized_persons: e.target.value })} placeholder="Nom, prénom, lien de parenté, téléphone..." rows={2} data-testid="wizard-authorized-persons" />
      </div>
      <div>
        <Label>Contacts d'urgence</Label>
        <Textarea value={data.emergency_contacts} onChange={(e) => onChange({ ...data, emergency_contacts: e.target.value })} placeholder="Nom, téléphone, lien..." rows={2} data-testid="wizard-emergency-contacts" />
      </div>
    </div>
    <Separator />
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <Baby className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Clauses particulières
      </h3>
      <div className="flex items-center justify-between p-3 rounded-lg border border-[var(--neutral-200)]">
        <div><Label className="font-semibold text-sm cursor-pointer">Présence d'animaux domestiques</Label></div>
        <Switch checked={data.has_pets} onCheckedChange={(checked) => onChange({ ...data, has_pets: checked })} data-testid="wizard-has-pets" />
      </div>
      {data.has_pets && (
        <Input value={data.pets_details} onChange={(e) => onChange({ ...data, pets_details: e.target.value })} placeholder="Type d'animal, précautions..." data-testid="wizard-pets-details" />
      )}
      <div className="flex items-center justify-between p-3 rounded-lg border border-[var(--neutral-200)]">
        <div><Label className="font-semibold text-sm cursor-pointer">Accueil périscolaire</Label></div>
        <Switch checked={data.periscolaire} onCheckedChange={(checked) => onChange({ ...data, periscolaire: checked })} data-testid="wizard-periscolaire" />
      </div>
      {data.periscolaire && (
        <Input value={data.periscolaire_details} onChange={(e) => onChange({ ...data, periscolaire_details: e.target.value })} placeholder="Conditions de l'accueil périscolaire..." data-testid="wizard-periscolaire-details" />
      )}
      <div>
        <Label>Besoins particuliers de l'enfant</Label>
        <Textarea value={data.special_needs} onChange={(e) => onChange({ ...data, special_needs: e.target.value })} placeholder="Allergies, régime alimentaire, protocole médical..." rows={2} data-testid="wizard-special-needs" />
      </div>
      <div>
        <Label>Contraintes de l'employeur</Label>
        <Textarea value={data.employer_constraints} onChange={(e) => onChange({ ...data, employer_constraints: e.target.value })} placeholder="Horaires variables, déplacements professionnels..." rows={2} data-testid="wizard-employer-constraints" />
      </div>
    </div>
    {children}
  </div>
);
